import { __exports as u } from "./index118.js";
import { __require as l } from "./index88.js";
import { __require as v } from "./index112.js";
import { __require as _ } from "./index115.js";
import { __require as x } from "./index117.js";
import { __require as b } from "./index111.js";
var m;
function j() {
  if (m) return u;
  m = 1;
  var f = u && u.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(u, "__esModule", { value: !0 }), u.Identify = void 0;
  var i = l(), o = f(v()), y = f(_()), h = f(x()), c = f(b()), n = function(t) {
    return t.trim();
  };
  function d(t, e) {
    i.Facade.call(this, t, e);
  }
  u.Identify = d, y.default(d, i.Facade);
  var r = d.prototype;
  return r.action = function() {
    return "identify";
  }, r.type = r.action, r.traits = function(t) {
    var e = this.field("traits") || {}, a = this.userId();
    t = t || {}, a && (e.id = a);
    for (var s in t) {
      var p = this[s] == null ? this.proxy("traits." + s) : this[s]();
      p != null && (e[t[s]] = p, s !== t[s] && delete e[s]);
    }
    return e;
  }, r.email = function() {
    var t = this.proxy("traits.email");
    if (t)
      return t;
    var e = this.userId();
    if (h.default(e))
      return e;
  }, r.created = function() {
    var t = this.proxy("traits.created") || this.proxy("traits.createdAt");
    if (t)
      return c.default(t);
  }, r.companyCreated = function() {
    var t = this.proxy("traits.company.created") || this.proxy("traits.company.createdAt");
    if (t)
      return c.default(t);
  }, r.companyName = function() {
    return this.proxy("traits.company.name");
  }, r.name = function() {
    var t = this.proxy("traits.name");
    if (typeof t == "string")
      return n(t);
    var e = this.firstName(), a = this.lastName();
    if (e && a)
      return n(e + " " + a);
  }, r.firstName = function() {
    var t = this.proxy("traits.firstName");
    if (typeof t == "string")
      return n(t);
    var e = this.proxy("traits.name");
    if (typeof e == "string")
      return n(e).split(" ")[0];
  }, r.lastName = function() {
    var t = this.proxy("traits.lastName");
    if (typeof t == "string")
      return n(t);
    var e = this.proxy("traits.name");
    if (typeof e == "string") {
      var a = n(e).indexOf(" ");
      if (a !== -1)
        return n(e.substr(a + 1));
    }
  }, r.uid = function() {
    return this.userId() || this.username() || this.email();
  }, r.description = function() {
    return this.proxy("traits.description") || this.proxy("traits.background");
  }, r.age = function() {
    var t = this.birthday(), e = o.default(this.traits(), "age");
    if (e != null)
      return e;
    if (t instanceof Date) {
      var a = /* @__PURE__ */ new Date();
      return a.getFullYear() - t.getFullYear();
    }
  }, r.avatar = function() {
    var t = this.traits();
    return o.default(t, "avatar") || o.default(t, "photoUrl") || o.default(t, "avatarUrl");
  }, r.position = function() {
    var t = this.traits();
    return o.default(t, "position") || o.default(t, "jobTitle");
  }, r.username = i.Facade.proxy("traits.username"), r.website = i.Facade.one("traits.website"), r.websites = i.Facade.multi("traits.website"), r.phone = i.Facade.one("traits.phone"), r.phones = i.Facade.multi("traits.phone"), r.address = i.Facade.proxy("traits.address"), r.gender = i.Facade.proxy("traits.gender"), r.birthday = i.Facade.proxy("traits.birthday"), u;
}
export {
  j as __require
};
//# sourceMappingURL=index91.js.map
